import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import HowItWorks from '../components/HowItWorks';
import AboutSection from '../components/AboutSection';
import BookingPreview from '../components/BookingPreview';
import VehicleOwners from '../components/VehicleOwners';
import TechSafety from '../components/TechSafety';
import Testimonials from '../components/Testimonials';
import CallToAction from '../components/CallToAction';

const HomePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>AbleGo - Inclusive Transport with Compassion</title>
        <meta name="description" content="AbleGo provides safe, supportive transport services with trained companions for individuals with health challenges, disabilities, and vulnerabilities across the UK." />
        <meta property="og:title" content="AbleGo - Inclusive Transport with Compassion" />
        <meta property="og:description" content="Book accessible transport across the UK, powered by intelligent routing and human support. Reliable, assisted travel for people with disabilities, health conditions, and mobility needs." />
        <link rel="canonical" href="https://ablego.co.uk" />
      </Helmet>
      <Hero />
      <AboutSection />
      <HowItWorks />
      <BookingPreview />
      <VehicleOwners />
      <TechSafety />
      <Testimonials />
      <CallToAction />
    </>
  );
};

export default HomePage;